module.exports = __webpack_public_path__ + "static/media/banner2.64ad5371.jpg";